


































































































































import { Component, Vue } from "vue-property-decorator";
import { storeLabSupervisi } from "@/store/modules/LabSupervisiStore";
import LabSupervisiSvc from "@/services/LabSupervisiService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import moment from "moment";
import LabSupervisiForm from "./LabSupervisiForm.vue";
import LabSupervisiDetail from "./LabSupervisiDetail.vue";

@Component({
  components: { LabSupervisiForm, LabSupervisiDetail }
})
export default class LabSupervisiList extends Vue {
  storeModule = storeLabSupervisi;
  showDetail = false;
  editData: any = null;
  isReadonly = false;

  filterTanggalDari = "";
  filterTanggalSampai = "";
  filterStatus = "";
  filterUnitLab = "";

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Menunggu Acknowledge", value: "submitted" },
    { text: "Acknowledged", value: "acknowledged" },
    { text: "Closed", value: "closed" },
  ];

  unitLabOptions = [
    { text: "Patologi Klinik", value: "patologi_klinik" },
    { text: "Patologi Anatomi", value: "patologi_anatomi" },
    { text: "Mikrobiologi", value: "mikrobiologi" },
    { text: "Bank Darah", value: "bank_darah" },
  ];

  headers = [
    { text: "No. Formulir", value: "nomor_formulir", width: "150px" },
    { text: "Tanggal", value: "tanggal_supervisi", width: "110px" },
    { text: "Supervisor", value: "supervisor_nama" },
    { text: "Unit Lab", value: "unit_lab", width: "120px" },
    { text: "Temuan Utama", value: "temuan_utama" },
    { text: "Status", value: "status", width: "130px" },
    { text: "Aksi", value: "actions", sortable: false, width: "100px" },
  ];

  mounted() {
    this.loadData();
  }

  async loadData() {
    const params: any = {};
    if (this.filterTanggalDari) params.tanggal_dari = this.filterTanggalDari;
    if (this.filterTanggalSampai) params.tanggal_sampai = this.filterTanggalSampai;
    if (this.filterStatus) params.status = this.filterStatus;
    if (this.filterUnitLab) params.unit_lab = this.filterUnitLab;
    await this.storeModule.loadSessions(params);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  unitLabLabel(val: string) {
    const map: Record<string, string> = {
      patologi_klinik: "Patologi Klinik",
      patologi_anatomi: "Patologi Anatomi",
      mikrobiologi: "Mikrobiologi",
      bank_darah: "Bank Darah",
    };
    return map[val] || val || "Seluruh Instalasi";
  }

  tambahBaru() {
    this.editData = null;
    this.isReadonly = false;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.isReadonly = item.is_locked;
    this.showDetail = true;
  }

  bisaHapus(item: any): boolean {
    if (!item.is_locked) return true;
    const slots = [
      { ditandatangani: item.signed_supervisor_at, penandaTanganId: item.supervisor_id },
      { ditandatangani: item.signed_ka_instalasi_at, penandaTanganId: item.signed_ka_instalasi_id }
    ];
    if (!slots.some(slot => !!slot.ditandatangani)) return false;
    return !alasanTtdMengunciHapus(item.creator_user_id || item.supervisor_id, slots, userModule.user?.id);
  }

  async hapus(item: any) {
    if (!this.bisaHapus(item)) return;
    if (!confirm("Hapus data supervisi ini?")) return;
    try {
      const resp = await LabSupervisiSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus data");
        this.loadData();
      }
    } catch {
      // handled by ErrorAlert
    }
  }

  printPdf(id: number) {
    LabSupervisiSvc.printPdf(id);
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }
}
